// src/pages/Swap/components/PercentageButton.tsx
import { FC } from "react";

interface PercentageButtonProps {
    percentage: number;
    onClick: () => void;
    isActive: boolean;
    mobile?: boolean;
}

const PercentageButton: FC<PercentageButtonProps> = ({ percentage, onClick, isActive, mobile }) => {
    return (
        <button
            type="button"
            onClick={onClick}
            className={`
                text-accent hover:text-white px-2
                ${
                    isActive
                        ? "opacity-100 cursor-pointer" // Apply active styles
                        : "pointer-events-none" // Apply inactive styles
                }
                ${
                    mobile
                        ? " text-xs rounded-full assented py-2" // Add mobile-specific styles if needed
                        : "" // Default styles for desktop
                }
            `}
            disabled={!isActive} // Disable button when not active
        >
            {percentage * 100}%
        </button>
    );
};

export default PercentageButton;
